var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('span',[_c('span',{staticClass:"gl-text-subtle"},[_vm._v(_vm._s(_vm.data.iterationCadence.title))]),_vm._v(" •\n  "),_c('gl-link',{attrs:{"href":_vm.data.webUrl}},[_vm._v(_vm._s(_vm.getIterationPeriod(_vm.data))),(_vm.data.title)?_c('span',[_vm._v(" • "+_vm._s(_vm.data.title))]):_vm._e()])],1):_c('null-presenter')
}
var staticRenderFns = []

export { render, staticRenderFns }